import { Link } from "react-router-dom";
import { Newspaper, Sparkles } from "lucide-react";

export const RelatedReading = ({ articles, className = "" }) => {
  if (!articles?.length) return null;
  return (
    <div data-testid="related-reading" className={className}>
      <h3 className="font-display font-bold text-xl mb-4 rule-thick pt-4 flex items-center gap-2">
        <Newspaper className="w-5 h-5 text-[#7d1a1a]" /> Related Reading
      </h3>
      <div className="space-y-3">
        {articles.map((a) => (
          <Link key={a.id} to={`/news/${a.id}`} data-testid={`related-article-${a.id}`} className="block bg-[#fbf8f1] border border-[#d8ccb8] p-4 hover:border-[#7d1a1a] transition-colors group">
            <p className="eyebrow flex items-center gap-2">
              {a.category}
              {a.ai_generated && <Sparkles className="w-3 h-3 text-[#b06810]" />}
            </p>
            <p className="font-display font-semibold text-base mt-1 leading-snug group-hover:text-[#7d1a1a] transition-colors">{a.title}</p>
            <p className="text-xs text-[#8a7c6d] mt-1 line-clamp-2">{a.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
